import { useCallback, useEffect, useState } from "react"
import { defaultGameBoardCTX } from "../context/defaultContext"
import {
  handleAutoInputsHelper,
  handleFuncsInContext,
  handleSettingsHelper,
  handleShowAutoHelper,
  handleStakeHelper,
  setFooterFirstStateHelper,
  setFooterSecondStateHelper,
  handleIsplayingHelper,
  handleSettingsSubpageHelper,
  handleJackpotPopupHelper,
  // handleAutoInputsSocketHelper
} from "./handleContextHelper"

export default function useGameBoardContextUpdate() {
  const [ctx, setctx] = useState(defaultGameBoardCTX)

  const handleStake = useCallback(
    (first: string, second: string) => {
      handleStakeHelper(first, second, setctx)
    },
    [setctx],
  )
  const handleSettings = useCallback(
    (show: boolean) => handleSettingsHelper(show, setctx),
    [setctx],
  )

  const handleSettingsSubpage = useCallback(
    (page: string) => handleSettingsSubpageHelper(page, setctx),
    [setctx],
  )

  const handleShowAuto = useCallback(
    (showFirst: boolean, showSecond: boolean) =>
      handleShowAutoHelper(showFirst, showSecond, setctx),
    [setctx],
  )
  const handleJackpotPopup = useCallback(
    (popup: boolean) => handleJackpotPopupHelper(popup, setctx),
    [setctx],
  )

  const handleAutoInputs = useCallback(
    (inputNumber: string, key: string, value: string) =>
      handleAutoInputsHelper(inputNumber, key, value, setctx),
    [setctx],
  )
  //TODO ავტოს სეთინგების შენახვისთვის გვექნება თუ დავამატებთ მომავალში
  // const handleAutoInputsSocket = useCallback(
  //   (inputNumber: string, numberOfBets: string, cashOut: string) =>
  //     handleAutoInputsSocketHelper(inputNumber, numberOfBets, cashOut, setctx),
  //   [setctx],
  // )

  const setFooterFirstState = useCallback(
    (state: string) => setFooterFirstStateHelper(state, setctx),
    [setctx],
  )
  const setFooterSecondState = useCallback(
    (state: string) => setFooterSecondStateHelper(state, setctx),
    [setctx],
  )

  const handleIsPlaying = useCallback(
    () => handleIsplayingHelper(setctx),
    [setctx],
  )

  useEffect(() => {
    handleIsPlaying()
  }, [ctx.auto, ctx.footerStates])

  useEffect(() => {
    handleFuncsInContext(
      setctx,
      handleStake,
      handleShowAuto,
      handleSettings,
      handleAutoInputs,
      setFooterFirstState,
      setFooterSecondState,
      handleSettingsSubpage,
      handleJackpotPopup,
      // handleAutoInputsSocket,
    )
  }, [
    handleStake,
    handleShowAuto,
    handleSettings,
    handleAutoInputs,
    setFooterFirstState,
    setFooterSecondState,
    handleSettingsSubpage,
    handleJackpotPopup,
    // handleAutoInputsSocket
  ])

  return {
    ctx,
    setctx,
    handleStake,
  }
}
